import { newTrack } from '@/track'
import { useHistoryStore } from '@/stores'

export function useFinishedView() {
  const finishedView = function (params: {
    contentId: string
    serialStatus: string
    showNum: number
    title: string
  }) {
    const historyStore = useHistoryStore()
    const prevPage: any = historyStore.$state.prevPage

    newTrack('biz_finished_view', {
      contentId: params.contentId,
      serial_status: params.serialStatus,
      show_num: params.showNum,
      title: params.title,
      route_title: prevPage?.route_title || '',
      route_host: prevPage?.route_host || '',
      route_url: prevPage?.route_url || '',
    })
  }

  return {
    finishedView,
  }
}
